<div class="wrapper">
    <router-outlet></router-outlet>
</div>
